import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { TreeProgression } from 'components/dashboard/TreeProgression';
import { useState } from 'react';
import { DaymadeDesignSystemPreviewComponentInfo } from '../';

const ComponentPreview = () => {
  const [treeDebug, setTreeDebug] = useState(false);
  return (
    <AboutUsModule background="white">
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">Tree progression</h3>
        <p>
          A component that shows how many trees a user has planted. It is
          designed to fill its container. Therefore, it is up to the parent to
          ensure the width and the height are appropriate for the component to
          fill. e.g. it may appear in a flexbox element that forces its height
          to match its sibling's height
        </p>
        <div
          style={{ display: 'flex', gap: 16, width: '100%', marginBottom: 16 }}
        >
          <TreeProgression treeCount={3} />
          <div
            style={{
              display: 'flex',
              height: 400,
              background: 'purple',
              color: '#fff',
              textAlign: 'center',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            Height 400px
          </div>
        </div>
        <div style={{ display: 'flex', gap: 16, width: '100%' }}>
          <TreeProgression treeCount={3} />
          <div
            style={{
              display: 'flex',
              height: 600,
              background: 'purple',
              color: '#fff',
              textAlign: 'center',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            Height 600px
          </div>
        </div>
        <p>
          <input
            id="treeDebug"
            type="checkbox"
            checked={treeDebug}
            onClick={() => setTreeDebug((x) => !x)}
          />{' '}
          <label htmlFor="treeDebug">Only show tree for given index</label>
        </p>
        <div style={{ display: 'grid', gap: 16, gridTemplate: '1fr' }}>
          {Array.from({ length: 20 }, (_, count) => (
            <TreeProgression treeCount={count} onlySpecifiedTree={treeDebug} />
          ))}
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Tree Progression',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
